(() => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.getElementById('main-navigation');
  const closeMenu = (restore = false) => {
    menu?.setAttribute('aria-expanded', 'false');
    nav?.classList.remove('is-open');
    if (restore) menu?.focus();
  };
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
  });
  nav?.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') closeMenu(true);
  });
  document.addEventListener('click', event => {
    if (menu?.getAttribute('aria-expanded') === 'true' && !event.target.closest('.ed-header')) closeMenu();
  });
  const desktop = matchMedia('(min-width: 821px)');
  desktop.addEventListener('change', event => { if (event.matches) closeMenu(); });
  const params = new URLSearchParams(location.search);
  [['InquiryInterest', 'interest'], ['InquiryMonth', 'month']].forEach(([id, param]) => {
    const choice = document.getElementById(id);
    const value = params.get(param);
    if (choice && value && [...choice.options].some(option => option.value === value)) choice.value = value;
  });
  document.querySelectorAll('[data-booking-card]').forEach(card => {
    const select = card.querySelector('[data-month-select]');
    const button = card.querySelector('[data-book-button]');
    const status = card.querySelector('[data-book-status]');
    const link = card.querySelector('[data-month-inquiry]');
    if (!select || !button || !status) return;
    const options = [...select.options];
    const requested = options.find(option => option.dataset.month === params.get('month'));
    const firstAvailable = options.find(option => option.dataset.available === 'true');
    if (requested) select.value = requested.value;
    else if (firstAvailable) select.value = firstAvailable.value;
    const render = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const priced = option.dataset.priced === 'true';
      button.disabled = !(available && priced);
      status.textContent = option.dataset.message || '';
      card.classList.toggle('is-sold-out', !available);
      button.textContent = !available ? card.dataset.soldout : priced ? card.dataset.reserve : card.dataset.unavailable;
      if (link) {
        const url = new URL(link.href, location.href);
        url.searchParams.set('interest', link.dataset.interest);
        url.searchParams.set('month', option.dataset.month || option.textContent);
        link.href = url.toString();
      }
    };
    select.addEventListener('change', render);
    render();
  });
})();
